<template>
  <div id="user-menu">
    <!-- Dark Mode -->
    <v-switch
      class="ml-4 mb-3"
      v-model="$vuetify.theme.dark"
      hide-details
      inset
      label="Dark Mode">
    </v-switch>
    <!-- / Dark Mode -->

    <!-- User Menu -->
    <v-menu
      offset-x
      bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          id="user-menu-activate"
          class="w-100 d-block px-1 plain"
          v-on="on">
          <v-icon>mdi-account-outline</v-icon>
          <div class="mx-auto text-truncate">
            {{$store.state.user.UserGivenName}}
          </div>
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </template>

      <v-list
        id="user-menu"
        class="text-center">
        <v-list-item
          @click="openUpdatePasswordModal">
          <v-list-item-title>Update Password</v-list-item-title>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          @click="signOut">
          <v-list-item-title>Sign Out</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- / User Menu -->
  </div>
</template>

<script>
import { browserStorage } from '../browser-storage';

export default {
  name: 'UserMenu',
  methods: {
    signOut() {
      this.$store.dispatch('signOut');
      this.$router.push({ name: 'SignInPage' });
    },
    openUpdatePasswordModal() {
      this.$store.commit('setUserUpdatePasswordModalFormOpen', true);
      this.$store.commit('setActiveUserUpdatePassword');
    },
  },
  watch: {
    '$vuetify.theme.dark': function (dark) {
      browserStorage.localStorageSet('darkMode', dark);
    },
  },
};
</script>

<style lang="scss">
#user-menu {
  label {
    margin: 0;
  }
}
</style>
